import pieChart2Fill from "@iconify/icons-eva/pie-chart-2-fill";
import barchartfill from "@iconify/icons-eva/bar-chart-fill";
import { Icon } from "@iconify/react";

const getEvaIcon = (name, hFlip) => (
  <Icon
    className="navbar-icon"
    icon={name}
    width={22}
    height={22}
    hFlip={hFlip}
  />
);

let sidebarConfig = ({ type, userInfo }) => {
  const sidebarConfig = [
    {
      title: "Dashboard",
      path: "/dashboard",
      icon: getEvaIcon(pieChart2Fill),
    },
    {
      title: "My Calendar",
      path: "/calendar-events",
      icon: getEvaIcon("mdi:calendar"),
    },
    {
      title: "Programmes",
      icon: getEvaIcon(barchartfill),
      child_options: [
        {
          title: "Active Programmes",
          path: "/programmes-folder",
          icon: getEvaIcon(barchartfill),
        },
        {
          title: "Inactive Programmes",
          path: "/inactive-programmes",
          icon: getEvaIcon(barchartfill),
        },
      ],
    },
    {
      title: "Your Information",
      path: "/coach_forms",
      icon: getEvaIcon("heroicons-solid:information-circle"),
      info: userInfo?.formcount,
    },
  ];

  // Coach workspace (Nov 2026): "Today" right under Dashboard. Check-in
  // planner + Check-in questions are inside "Trackers" below. No old item removed.
  if (type !== "team") {
    sidebarConfig.splice(1, 0, {
      title: "Today",
      path: "/coach/today",
      // NAV-OPEN (3 Nov): review + feedback pages are opened from Today's queue.
      matches: ["/coach/today", "/coach/review"],
      icon: getEvaIcon("mdi:calendar-today"),
    });
    // CLIENTS (3 Nov): new Clients list under Today ("Members" stays below).
    sidebarConfig.splice(2, 0, {
      title: "Clients",
      path: "/coach/clients",
      icon: getEvaIcon("mdi:account-group"),
    });
  }

  if (type !== "team") {
    sidebarConfig.push({
      title: "Members",
      path: "/members",
      icon: getEvaIcon("mdi:person", true),
    });
  }
  sidebarConfig.push({
    title: "Chat",
    path: "/chat",
    icon: getEvaIcon("mdi:chat"),
  });
  if (type !== "team") {
    sidebarConfig.push({
      title: "Fitness",

      icon: getEvaIcon("mdi:gym"),
      child_options: [
        {
          title: "Exercise library",
          path: "/exercise",
          icon: getEvaIcon("healthicons:exercise-walking"),
        },
        {
          title: "Exercises Type",
          path: "/type-exercise",
          icon: getEvaIcon("healthicons:exercise-walking"),
        },
        {
          title: "Workout Library",
          path: "/workout_library",
          icon: getEvaIcon("mdi:gym"),
        },
        {
          title: "Workout Type",
          path: "/workout_type",
          icon: getEvaIcon("mdi:gym"),
        },
      ],
    });
  }
  if (type !== "team") {
    sidebarConfig.push({
      title: "Nutrition",
      icon: getEvaIcon("fluent:food-24-filled"),
      child_options: [
        {
          title: "Daily Meal Plan",
          path: "/nutrition_library",
          icon: getEvaIcon("fluent:food-24-filled"),
        },
        {
          title: "Diet Type",
          path: "/nutrition_type",
          icon: getEvaIcon("fluent:food-24-filled"),
        },
        {
          title: "Food Database",
          path: "/food",
          icon: getEvaIcon("fluent:food-24-filled"),
        },
      ],
    });
  }
  if (type !== "team") {
    sidebarConfig.push({
      title: "Mindset",

      icon: getEvaIcon("flowbite:brain-outline"),
      child_options: [
        {
          title: "Mindset Library",
          path: "/mindset_library",

          icon: getEvaIcon("flowbite:brain-outline"),
        },
        {
          title: "Mindset Type",
          path: "/mindset_type",
          icon: getEvaIcon("flowbite:brain-outline"),
        },
      ],
    });
  }
  if (type !== "team") {
    sidebarConfig.push({
      title: "Workbook",
      icon: getEvaIcon("mdi:book-open-page-variant-outline"),
      child_options: [
        {
          title: "Workbook Library",
          path: "/workbook_library",
          icon: getEvaIcon("mdi:book-open-page-variant-outline"),
        },
      ],
    });
  }
  if (type !== "team") {
    sidebarConfig.push({
      title: "Videos",
      icon: getEvaIcon("octicon:video-24"),
      child_options: [
        {
          title: "Videos Library",
          path: "/video_library",
          icon: getEvaIcon("octicon:video-24"),
        },
        {
          title: "Videos Type",
          path: "/video_type",
          icon: getEvaIcon("octicon:video-24"),
        },
      ],
    });
  }
  if (type !== "team") {
    sidebarConfig.push({
      title: "Comments",
      icon: getEvaIcon("eva:message-square-fill"),
      child_options: [
        {
          title: "Comment Library",
          path: "/comment_library",
          icon: getEvaIcon("eva:message-square-fill"),
        },
        {
          title: "Comment Type",
          path: "/comment_type",
          icon: getEvaIcon("eva:message-square-fill"),
        },
      ],
    });
  }

  if (type !== "team") {
    sidebarConfig.push({
      title: "Community Area",
      icon: getEvaIcon("healthicons:group-discussion-meetingx3"),
      child_options: [
        {
          title: "General Community Area",
          path: "/community-area",

          icon: getEvaIcon("fluent:people-community-16-filled"),
        },
        {
          title: "Pending Posts",
          path: "/pending-posts",
          icon: getEvaIcon("mdi:account-pending"),
        },
        {
          title: "Rejected Posts",
          path: "/rejected-posts",
          icon: getEvaIcon("mdi:account-cancel"),
        },
        {
          title: "Groups",
          path: "/feed-groups",
          icon: getEvaIcon("fluent:people-community-16-filled"),
        },
      ],
    });
  }

  if (type !== "team") {
    sidebarConfig.push({
      title: "Client Portal",

      icon: getEvaIcon("fluent:settings-20-filled"),
      child_options: [
        {
          title: "User Form",
          path: "/form-list",
          icon: getEvaIcon("fluent:form-48-filled"),
        },
        {
          title: "User Form Templates",
          path: "/user_form-templates",
          icon: getEvaIcon("fluent:form-48-filled"),
        },
      ],
    });
  }
  if (type !== "team") {
    sidebarConfig.push({
      title: "Trackers",
      icon: getEvaIcon("mdi:clipboard-list-outline"),
      child_options: [
        {
          title: "Trackers",
          path: "/trackers",
          icon: getEvaIcon("mdi:clipboard-list-outline"),
        },
        {
          title: "Submissions",
          path: "/tracker-submissions",
          icon: getEvaIcon("mdi:inbox-outline"),
        },
        {
          title: "My reviews",
          path: "/tracker-reviews",
          icon: getEvaIcon("mdi:clipboard-check-outline"),
        },
        {
          title: "Check-in planner",
          path: "/coach/check-ins/planner",
          icon: getEvaIcon("mdi:calendar-week"),
        },
        {
          title: "Check-in questions",
          path: "/coach/check-ins/questions",
          icon: getEvaIcon("mdi:format-list-checks"),
        },
        {
          title: "Automations",
          path: "/tracker-automations",
          icon: getEvaIcon("mdi:robot-outline"),
        },
      ],
    });
  }
  sidebarConfig.push({
    title: "Helping Videos",
    icon: getEvaIcon("fluent:video-clip-20-filled"),
    child_options: [
      {
        title: "Helping Videos",
        path: "/helping_videos_category",
        icon: getEvaIcon("ic:round-video-library"),
      },
      {
        title: "Member Videos",
        path: "/members_videos_category",
        icon: getEvaIcon("ic:round-video-library"),
      },
    ],
  });
  sidebarConfig.push({
    title: "Support Ticket",
    path: "/support-ticket",
    icon: getEvaIcon("ic:round-support-agent"),
  });
  sidebarConfig.push({
    title: "Gym TV",
    path: "/WorkoutDisplay",
    icon: getEvaIcon("ic:baseline-tv"),
  });

  return sidebarConfig;
};

export default sidebarConfig;
